export default function QRCodeCtrl($scope, $stateParams) {

  $scope.qid = $stateParams.id;

}
